// Antd
import { Menu, Dropdown } from 'antd'

// Components
import { BaseImage } from 'components'

// Interfaces
import { IBaseTableActionProps } from './interfaces'

// i18n
import { useTranslation } from 'react-i18next'

// Custom Hooks
import { useUploader } from 'hooks'

const BaseTableAction = ({
  isShow,
  isEdit,
  isDelete,
  isDownload,
  downloadOption,
  onClickShow,
  onClickDelete,
  onClickEdit,
  anotherAction,
  editLabel,
  downloadLabel,
  onUpload,
}: IBaseTableActionProps) => {
  // Hook
  const { t } = useTranslation()
  const { uploader_Input, uploader_onClickSingleFile } = useUploader({
    acceptedExtensions: ['*'],
  })

  // Render menu
  const menus = (
    <Menu>
      {/* Show Action */}
      {isShow && (
        <Menu.Item key="show" onClick={onClickShow}>
          {t('app.action.show')}
        </Menu.Item>
      )}

      {/* Edit Action */}
      {isEdit && (
        <Menu.Item key="edit" onClick={onClickEdit}>
          {editLabel ? editLabel : t('app.action.edit')}
        </Menu.Item>
      )}

      {/* Download Action */}
      {isDownload && (
        <Menu.Item key="download">
          <a href={downloadOption?.url!} target="_blank" rel="noreferrer">
            {t(downloadLabel || 'app.action.downloadFile')}
          </a>
        </Menu.Item>
      )}

      {/* Render another action  */}
      {anotherAction &&
        anotherAction.length !== 0 &&
        anotherAction.map(action => (
          <Menu.Item key={action.label} onClick={action.isUpload ? uploader_onClickSingleFile : action.onClick}>
            {t(action.label)}
          </Menu.Item>
        ))}

      {/* Render Disabled Action - Only If Another Action is Empty */}
      {anotherAction && anotherAction.length === 0 && <></>}

      {/* Delete Action */}
      {isDelete && (
        <Menu.Item key="delete" onClick={onClickDelete}>
          {t('app.action.delete')}
        </Menu.Item>
      )}
    </Menu>
  )

  return (
    <div className="cursor-pointer">
      {onUpload && uploader_Input(onUpload)}

      <Dropdown overlay={menus} trigger={['click']}>
        <BaseImage isIcon isSvg icon="icon-triple-dot" />
      </Dropdown>
    </div>
  )
}

BaseTableAction.defaultProps = {
  isShow: true,
  isEdit: true,
  isDelete: true,
}

export { BaseTableAction }
